// The Chats nav badge (sidebar + tab bar), in chats: unread chat keys, minus pending DM requests
// (counted once, as requests) and requests I declined, minus the room that is open and focused,
// plus incoming connection requests and standalone DM requests.
//
// The open room is left out with mobile's otherUnreadChatCount semantics (ChatHeader.js): its
// chat-message notice is written after the room already marked that message read (the sender's
// fan-out runs after addDoc), so it would otherwise show as "1 unread" for the chat being read.
// `openRoom` is { chatId, chatType } (E-Board keys as eboardKey(chatId)) or null.
import { otherUnreadChatCount } from "../../../utils/chatUnread";

export function chatsBadgeCount({
  unreadChatIds = [],
  dmRequestIds = [],
  declinedDmIds = [],
  incomingConnections = 0,
  standaloneDmRequests = 0,
  openRoom = null,
} = {}) {
  const requests = new Set(dmRequestIds);
  const declined = new Set(declinedDmIds);
  const chats = unreadChatIds.filter((id) => !requests.has(id) && !declined.has(id));
  const unread = openRoom?.chatId ? otherUnreadChatCount(chats, openRoom.chatId, openRoom.chatType) : chats.length;
  return unread + incomingConnections + standaloneDmRequests;
}
